import { Actions, ActionTypes, FetchDraftsResponse, GetDrafts, GetDraftsReason } from './actions';
import { DraftOrder } from '../../types/orders';
import { DraftOrGap } from './types';
import { isDraftOrder } from './helpers';
import { mergeLists } from '../../helpers/paging';
import { paramsEqual } from '../../helpers/urlParams';

export interface State {
    isLoading: boolean;
    limit: number;
    drafts: DraftOrGap[];
    hasNext: boolean;
    isLoadingNext: boolean;
    accountId: string;
    params: URLSearchParams;
    requestId: number;
}

export const initialState: State = {
    isLoading: true,
    limit: 20,
    drafts: [],
    hasNext: true,
    isLoadingNext: false,
    accountId: '',
    params: new URLSearchParams(),
    requestId: 0,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.GetDrafts:
            const clearList = shouldClearList(action, state);
            return {
                ...state,
                isLoading: true,
                isInvalid: false,
                isLoadingNext: action.payload.reason !== GetDraftsReason.refresh,
                accountId: action.payload.accountId,
                drafts: clearList ? [] : state.drafts,
                params: action.payload.params,
                requestId: action.payload.requestId,
            };

        case ActionTypes.FetchDraftsResponse:
            if (action.meta.cause.payload.requestId !== state.requestId) {
                return state;
            }
            return {
                ...state,
                isLoading: false,
                drafts: mergeDraftLists(action, state),
            };

        case ActionTypes.FetchNextResponse:
            return {
                ...state,
                hasNext: action.payload.drafts.length > 0,
                isLoadingNext: false,
            };

        case ActionTypes.MutateDraft:
            return {
                ...state,
                drafts: swapDraft(state.drafts, action.payload.draft),
            };

        default:
            return state;
    }
}

const shouldClearList = (action: GetDrafts, state: State) => {
    if (action.payload.accountId !== state.accountId) {
        return true;
    }
    if (action.payload.reason === GetDraftsReason.update) {
        return true;
    }
    const blacklist = ['starting_after', 'limit'];
    return !paramsEqual(action.payload.params, state.params, blacklist);
};

const mergeDraftLists = (action: FetchDraftsResponse, state: State): DraftOrGap[] => {
    // sanity check, should clear list
    if (shouldClearList(action.meta.cause, state)) {
        return action.payload.drafts;
    }

    const result = mergeLists<DraftOrder>(
        action.payload.drafts,
        state.drafts,
        action.meta.cause.payload.params.get('starting_after')
    );
    return result;
};

const swapDraft = (stateDrafts: DraftOrGap[], actionDraft: DraftOrder) => {
    return stateDrafts.map((stateDraft) => {
        if (isDraftOrder(stateDraft) && stateDraft.id === actionDraft.id) {
            return actionDraft;
        }
        return stateDraft;
    });
};
